/**
 * Module Staff #14 — Configuration système & sécurité
 */
const moduleStaffConfig = {
  id: 'staff-configuration',
  population: 'staff',
  order: 14,
  category: 'Admin',
  title: 'Configuration système',
  subtitle: 'Paramètres globaux, intégrations, sécurité avancée',
  icon: 'Shield',
  duration: '25 min',
  level: 'Avancé',
  audience: 'Admin IT, super_admin',
  slides: [
    { type: 'cover', eyebrow: 'Module 14 — Staff', title: 'Configuration système', subtitle: 'Paramètres globaux et intégrations', icon: 'Shield', duration: '25 min', audience: 'Admin IT', level: 'Avancé' },
    { type: 'intro', title: 'Objectifs', intro: 'La configuration système contrôle l\'ensemble des paramètres globaux Baobab. Réservée aux admins IT.', objectives: [
      'Configurer les objectifs business mensuels/annuels',
      'Gérer les intégrations (SendGrid, Stripe, WhatsApp)',
      'Configurer les seuils d\'alertes CFO',
      'Auditer les logs système',
      'Comprendre les flux RGPD et droits utilisateurs',
      'Gérer les raccourcis et préférences globales',
    ]},
    { type: 'concept', eyebrow: 'Sections', icon: 'BookOpen', title: 'Les 6 sections de configuration',
      bullets: [
        '🎯 Objectifs business : CA, volume, recouvrement, NPS',
        '🔌 Intégrations : SendGrid (email), Stripe, WhatsApp Cloud, FNE',
        '⚠️ Alertes : seuils DSO, concentration top 10, churn',
        '📋 Logs & Audit : qui a fait quoi, exportable, conservation 5 ans',
        '🛡️ RGPD : droit à l\'oubli, export données, consentements',
        '⚙️ Préférences : timezone, devise, format dates, langue',
      ],
      note: 'Toutes les modifications sont auditées et nécessitent un commentaire.',
    },
    { type: 'steps', title: 'Configurer SendGrid pour l\'envoi d\'emails', steps: [
      { title: 'Config → Intégrations → SendGrid', detail: 'Section dédiée.' },
      { title: 'Saisir l\'API Key SendGrid', detail: 'Format SG.xxx, fournie par l\'admin SendGrid.' },
      { title: 'Configurer l\'expéditeur', detail: 'Email + nom affiché (ex: "Baobab Connect <noreply@baobab.ci>")' },
      { title: 'Tester l\'envoi', detail: 'Bouton "Test" → email vers votre adresse.' },
      { title: 'Activer', detail: 'Toggle ON pour activer les envois automatiques.' },
    ]},
    { type: 'comparison', title: 'Configuration : do vs don\'t', do: [
      'Documenter chaque modification dans le commentaire',
      'Tester en sandbox avant production',
      'Sauvegarder les API keys dans un coffre-fort (1Password)',
      'Auditer mensuellement les logs',
      'Désactiver les intégrations inutilisées',
    ], dont: [
      'Pas de modif "directe en prod" sans backup',
      'Pas de partage d\'API keys par email/Slack',
      'Pas d\'objectifs irréalistes (-30 % d\'atteinte = démotivation)',
      'Pas d\'override des règles OHADA/RGPD',
      'Pas de log purgé < 5 ans',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Vous voulez désactiver temporairement les alertes WhatsApp. Comment ?',
      options: [
        'Supprimer l\'intégration WhatsApp',
        'Toggle OFF dans Config → Intégrations → WhatsApp Cloud, avec commentaire daté',
        'Désinstaller l\'app',
        'Bloquer le numéro',
      ],
      answerIndex: 1,
      explanation: 'Toggle OFF permet de réactiver en 1 clic plus tard. La suppression entraîne perte de config. Le commentaire daté = traçabilité.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      '6 sections : objectifs, intégrations, alertes, logs, RGPD, préférences.',
      'Toutes modifs auditées + commentées.',
      'API keys jamais en clair, jamais partagées.',
      'Test sandbox avant production.',
      'Conservation logs 5 ans (OHADA + RGPD).',
    ]},
    { type: 'cta', title: 'Module 14 terminé — Bravo !', subtitle: 'Vous avez parcouru les 14 modules staff. Vous maîtrisez 100 % de l\'application.',
      actions: [
        { label: 'Configuration', href: '/admin/settings' },
        { label: 'Catalogue', href: '/docs/admin/training' },
      ],
    },
  ],
};
export default moduleStaffConfig;
